define([
	"dojo/_base/declare",
	"csi/table/MoveUpDown"
], function(declare,MoveUpDown) {

	return declare(MoveUpDown, {
		onStart: function() {
			var kit = this.getParent();
			this.m_urlParent = this.m_cache.getNode(kit.BOMLineBOM).CurrentRevision;
			this.m_urlParentTarget = this.m_urlParent;
			this.m_idAttrParent = "Items";
			this.m_idAttrParentTarget = this.m_idAttrParent;
		}
	});
});